export default function initNewsletterForm() {
    window.addEventListener('load', function () {
        document.getElementById('newsletterForm').addEventListener('submit', event => {
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'form',
                    'form-name': 'NewsletterForm',
                    'form-topic': 'NewsletterForm',
                });
            }
            return true;
        });
    });
}
